export const BETTO_ALERT_ACTIONS = {
	CLOSE: "close",
	RESET_PASSWORD: "resetPassword",
	CONTACT_SUPPORT: "contactSupport",
	CONTACT_BANK: "contactBank",
	DEPOSIT: "deposit",
	EDIT_AMOUNT: "editAmount",
	WALLET: "wallet",
	HOME: "home",
	LOGIN: "login",
	SIGNUP: "signup",
	LOGOUT: "logout",
	PROFILE: "profile",
	VERIFY_AGAIN: "verifyAgain",
	RESEND_CODE: "resendCode",
	TRACK_WITHDRAWAL: "trackWithdrawal",
	BET_SLIP: "betSlip",
	PLACE_BET: "placeBet",
	RETRY: "retry",
	STAY_LOGGED_IN: "stayLoggedIn",
	CONTINUE_ANYWAY: "continueAnyway",
	ACCEPT: "accept",
};

export const BETTO_ALERT_VARIANTS = {
	"incorrect-password": {
		type: "error",
		titleKey: "betto.alert.incorrectPassword.title",
		messageKey: "betto.alert.incorrectPassword.message",
		fallbackMsgKey: "WRONG_USERNAME_OR_PASS",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.incorrectPassword.tryAgain",
				action: BETTO_ALERT_ACTIONS.LOGIN,
			},
			{
				variant: "secondary",
				labelKey: "betto.alert.incorrectPassword.resetPassword",
				action: BETTO_ALERT_ACTIONS.RESET_PASSWORD,
			},
		],
	},
	"invalid-verification-code": {
		type: "error",
		titleKey: "betto.alert.invalidVerificationCode.title",
		messageKey: "betto.alert.invalidVerificationCode.message",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.invalidVerificationCode.resendCode",
				action: BETTO_ALERT_ACTIONS.RESEND_CODE,
			},
			{
				variant: "secondary",
				labelKey: "betto.alert.invalidVerificationCode.verifyAgain",
				action: BETTO_ALERT_ACTIONS.VERIFY_AGAIN,
			},
		],
	},
	"too-many-login-attempts": {
		type: "error",
		titleKey: "betto.alert.tooManyLoginAttempts.title",
		messageKey: "betto.alert.tooManyLoginAttempts.message",
		fallbackMsgKey: "LimitExceededException",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.tooManyLoginAttempts.contactSupport",
				action: BETTO_ALERT_ACTIONS.CONTACT_SUPPORT,
			},
			{
				variant: "secondary",
				labelKey: "betto.alert.tooManyLoginAttempts.tryLater",
				action: BETTO_ALERT_ACTIONS.CLOSE,
			},
		],
	},
	"something-went-wrong": {
		type: "error",
		titleKey: "betto.alert.somethingWentWrong.title",
		messageKey: "betto.alert.somethingWentWrong.message",
		fallbackMsgKeys: ["ERROR_OCCURED", "GENERIC_ERROR"],
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.somethingWentWrong.retry",
				action: BETTO_ALERT_ACTIONS.RETRY,
			},
			{
				variant: "secondary",
				labelKey: "betto.alert.somethingWentWrong.contactSupport",
				action: BETTO_ALERT_ACTIONS.CONTACT_SUPPORT,
			},
		],
	},
	"payment-failed": {
		type: "error",
		titleKey: "betto.alert.paymentFailed.title",
		messageKey: "betto.alert.paymentFailed.message",
		fallbackMsgKey: "DEPOSIT_FAILED",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.paymentFailed.tryAgain",
				action: BETTO_ALERT_ACTIONS.DEPOSIT,
			},
			{
				variant: "secondary",
				labelKey: "betto.alert.paymentFailed.contactBank",
				action: BETTO_ALERT_ACTIONS.CONTACT_BANK,
			},
		],
	},
	"transaction-failed": {
		type: "error",
		titleKey: "betto.alert.transactionFailed.title",
		messageKey: "betto.alert.transactionFailed.message",
		fallbackMsgKey: "FAILED_DEPOSIT_OPERATION",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.transactionFailed.retryDeposit",
				action: BETTO_ALERT_ACTIONS.DEPOSIT,
			},
			{
				variant: "secondary",
				labelKey: "betto.alert.transactionFailed.contactSupport",
				action: BETTO_ALERT_ACTIONS.CONTACT_SUPPORT,
			},
		],
	},
	"insufficient-funds": {
		type: "info",
		titleKey: "betto.alert.insufficientFunds.title",
		messageKey: "betto.alert.insufficientFunds.message",
		fallbackMsgKey: "INSUFFICIENT_BALANCE",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.insufficientFunds.depositFunds",
				action: BETTO_ALERT_ACTIONS.DEPOSIT,
			},
			{
				variant: "secondary",
				labelKey: "betto.alert.insufficientFunds.editAmount",
				action: BETTO_ALERT_ACTIONS.EDIT_AMOUNT,
			},
		],
	},
	"deposit-completed": {
		type: "success",
		titleKey: "betto.alert.depositCompleted.title",
		messageKey: "betto.alert.depositCompleted.message",
		fallbackMsgKey: "DEPOSIT_SUCCESS",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.depositCompleted.viewBalance",
				action: BETTO_ALERT_ACTIONS.WALLET,
			},
			{
				variant: "secondary",
				labelKey: "betto.alert.depositCompleted.continueBetting",
				action: BETTO_ALERT_ACTIONS.PLACE_BET,
			},
		],
	},
	"welcome-platform": {
		type: "success",
		titleKey: "betto.alert.welcomePlatform.title",
		messageKey: "betto.alert.welcomePlatform.message",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.welcomePlatform.startExploring",
				action: BETTO_ALERT_ACTIONS.HOME,
				fullWidth: true,
			},
		],
	},
	"verification-complete": {
		type: "success",
		titleKey: "betto.alert.verificationComplete.title",
		messageKey: "betto.alert.verificationComplete.message",
		fallbackMsgKey: "VERIFICATION_LINK_VERIFIED",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.verificationComplete.continue",
				action: BETTO_ALERT_ACTIONS.CLOSE,
				fullWidth: true,
			},
		],
	},
	"request-submitted": {
		type: "success",
		titleKey: "betto.alert.requestSubmitted.title",
		messageKey: "betto.alert.requestSubmitted.message",
		fallbackMsgKey: "SUCCESSFULL_WITHDRAW",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.requestSubmitted.trackWithdrawal",
				action: BETTO_ALERT_ACTIONS.TRACK_WITHDRAWAL,
				fullWidth: true,
			},
		],
	},
	"bet-confirmed": {
		type: "success",
		titleKey: "betto.alert.betConfirmed.title",
		messageKey: "betto.alert.betConfirmed.message",
		fallbackMsgKey: "BET_CONFIRMED",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.betConfirmed.viewBetSlip",
				action: BETTO_ALERT_ACTIONS.BET_SLIP,
			},
			{
				variant: "secondary",
				labelKey: "betto.alert.betConfirmed.placeAnotherBet",
				action: BETTO_ALERT_ACTIONS.PLACE_BET,
			},
		],
	},
	"profile-updated": {
		type: "success",
		titleKey: "betto.alert.profileUpdated.title",
		messageKey: "betto.alert.profileUpdated.message",
		fallbackMsgKey: "PROFILE_UPDATED",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.profileUpdated.backToHome",
				action: BETTO_ALERT_ACTIONS.HOME,
				fullWidth: true,
			},
		],
	},
	"password-updated": {
		type: "success",
		titleKey: "betto.alert.passwordUpdated.title",
		messageKey: "betto.alert.passwordUpdated.message",
		fallbackMsgKey: "PASSWORD_UPDATED",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.passwordUpdated.backToHome",
				action: BETTO_ALERT_ACTIONS.HOME,
				fullWidth: true,
			},
		],
	},
	"low-wallet-balance": {
		type: "info",
		titleKey: "betto.alert.lowWalletBalance.title",
		messageKey: "betto.alert.lowWalletBalance.message",
		fallbackMsgKey: "LUCKY_BOX_DEPOSIT_REQUIRED",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.lowWalletBalance.depositFunds",
				action: BETTO_ALERT_ACTIONS.DEPOSIT,
			},
			{
				variant: "secondary",
				labelKey: "betto.alert.lowWalletBalance.continueAnyway",
				action: BETTO_ALERT_ACTIONS.CONTINUE_ANYWAY,
			},
		],
	},
	"session-expire": {
		type: "info",
		titleKey: "betto.alert.sessionExpire.title",
		messageKey: "betto.alert.sessionExpire.message",
		fallbackMsgKey: "SESSION_ABOUT_TO_EXPIRE",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.sessionExpire.stayLoggedIn",
				action: BETTO_ALERT_ACTIONS.STAY_LOGGED_IN,
			},
			{
				variant: "secondary",
				labelKey: "betto.alert.sessionExpire.logout",
				action: BETTO_ALERT_ACTIONS.LOGOUT,
			},
		],
	},
	"login-required": {
		type: "info",
		illustrationKey: "welcome-platform",
		titleKey: "betto.alert.loginRequired.title",
		messageKey: "betto.alert.loginRequired.message",
		fallbackMsgKey: "LOGIN_OR_SIGNUP_FIRST",
		buttons: [
			{
				variant: "primary",
				labelKey: "signin-signup.signIn",
				action: BETTO_ALERT_ACTIONS.LOGIN,
			},
			{
				variant: "secondary",
				labelKey: "signin-signup.signUp",
				action: BETTO_ALERT_ACTIONS.SIGNUP,
			},
		],
	},
	"profile-update-required": {
		type: "info",
		illustrationKey: "verification-complete",
		titleKey: "PROFILE_UPDATE_REQUIRED_TITLE",
		messageKey: "PROFILE_UPDATE_REQUIRED_MESSAGE",
		fallbackMsgKey: "PROFILE_UPDATE_REQUIRED_MESSAGE",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.header.goToProfile",
				action: BETTO_ALERT_ACTIONS.PROFILE,
				fullWidth: true,
			},
		],
	},
	"missing-national-id": {
		type: "error",
		illustrationKey: "something-went-wrong",
		titleKey: "betto.alert.missingNationalId.title",
		messageKey: "betto.alert.missingNationalId.message",
		fallbackMsgKey: "MISSING_NATIONAL_ID",
		buttons: [
			{
				variant: "primary",
				labelKey: "betto.alert.missingNationalId.contactSupport",
				action: BETTO_ALERT_ACTIONS.CONTACT_SUPPORT,
				fullWidth: true,
			},
		],
	},
};
